import { useState } from 'react';
import { useSnapshot } from 'valtio';
import { addAgencyLogo as apiAddLogoFile } from '~/api/civilsearch';
import UploadButton from '~/components2/forms/UploadButton';
import { Notify } from '~/components2/Notify';
import FormSection from '~/pages/admin/civilsearch/common/FormSection';
import store from '../../../store';

export default function AgencyLogo() {
  const [isProcessing, setIsProcessing] = useState(false);
  const { agency } = useSnapshot(store) as typeof store;
  const logoPath = agency?.logo?.path;

  const onUpload = async (files: File[]) => {
    try {
      setIsProcessing(true);
      const file = files[0];
      if (!file) throw new Error('No file found!');

      const data = new FormData();
      data.append('file', file);
      data.append('name', file.name);
      data.append('type', file.type);
      data.append('extension', file.name.split('.').pop()!);

      const res = await apiAddLogoFile(agency!.id, data);
      if (!res.id) throw new Error('Bad response!');

      if (store.agency?.id) {
        store.agency.logo = res.logo;
      }

      Notify.info({ message: 'Agency logo successfully uploaded!' });
    } catch (e) {
      console.error('Error uploading file', e);
      Notify.error({ message: 'An error occurred while uploading the file' });
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <FormSection title="Agency Logo">
      <div>
        {!!logoPath && (
          <div className="pb-2">
            <img src={logoPath} alt="Agency logo" className="max-h-[10rem] max-w-[30rem]" />
          </div>
        )}
        <UploadButton isProcessing={isProcessing} disabled={isProcessing} multiple={false} onUpload={onUpload}>
          Upload Logo
        </UploadButton>
      </div>
    </FormSection>
  );
}
